import window from '../globalWrappers/window.js';

export default () => window.location.pathname.split('/')[1];
